<template>
  <div id="app">
    <!-- <keep-alive> -->
      <router-view/>
    <!-- </keep-alive> -->
  </div>
</template>

<script>
  import './assets/css/default.css'
  export default {
    name: "App",
  }
</script>

<style>
  #app {
  }
</style>
